import React from 'react';

import cx from 'classnames';

import styles from './Container.module.scss';

export interface IContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const Container: React.FC<IContainerProps> = ({
  children,
  className,
}) => {
  return <div className={cx(styles.container, className)}>{children}</div>;
};
